import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../../app/services/aha-api";

const initialState = {
  value: [],
  loading: false,
};

export const updateTerritory = createAsyncThunk(
  "territories/updateTerritory",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.updateTerritory(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const updateTerritorySLice = createSlice({
  name: "updateTerritory",
  initialState,
  reducers: {
    clearUpdateTerritoryResponse(state, action) {
      state.value = {}
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateTerritory.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTerritory.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(updateTerritory.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const updateTerritoryList = (state) => state.updateTerritory.value;
export const updateTerritoryLoader = (state) => state.updateTerritory.loading;
export const {clearUpdateTerritoryResponse} = updateTerritorySLice.actions;

export default updateTerritorySLice.reducer;
